import { render, staticRenderFns } from "./SideWindow.vue?vue&type=template&id=45a3e096&"
import script from "./SideWindow.vue?vue&type=script&lang=js&"
export * from "./SideWindow.vue?vue&type=script&lang=js&"
import style0 from "./SideWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports